import { SearchResult } from '../SearchResult';
import { Text } from '@/ui-components/atoms/Text/Text';
import { Button } from '@/ui-components/atoms/Button/Button';
import styles from './newsroomcardgroup.module.scss';

const { cardGroupWrapper, headlineStyles, linkWrapper, textLinkStyles, cardStyling, titleStyles } = styles;

interface NewsroomCardProps {
    label: string;
    title: string;
    titleLink: string;
}

interface NewsroomCardGroupProps {
    articles: NewsroomCardProps[];
    headline: string;
    groupLink?: SiteLink;
}

export default function NewsroomCardGroup({
    articles,
    headline,
    groupLink,
}: NewsroomCardGroupProps): React.JSX.Element {
    const content = articles?.map((article, index) => {
        return (
            <SearchResult
                key={index}
                label={article.label}
                title={article.title}
                titleLink={{ href: article.titleLink }}
                variant="card"
                className={cardStyling}
                titleClassName={titleStyles}
            />
        );
    });

    return (
        <div>
            <Text tag="h2" variant="h2" className={headlineStyles}>
                {headline}
            </Text>
            <div className={cardGroupWrapper}>{content}</div>
            {groupLink && (
                <div className={linkWrapper}>
                    <Button
                        className={groupLink.fields?.theme === 'text' ? textLinkStyles : undefined}
                        type="button"
                        href={groupLink.fields?.href}
                        color={groupLink.fields?.ctaColor}
                        variant={groupLink.fields?.theme}
                        ariaLabel={groupLink.fields?.aria_label}
                        tertiaryNoPadding={groupLink.fields?.theme === 'tertiary'}
                    >
                        {groupLink.fields?.link_text}
                    </Button>
                </div>
            )}
        </div>
    );
}
